import { render, staticRenderFns } from "./schoolData_stuUse.vue?vue&type=template&id=7539d4c8&scoped=true&"
import script from "./schoolData_stuUse.vue?vue&type=script&lang=js&"
export * from "./schoolData_stuUse.vue?vue&type=script&lang=js&"
import style0 from "./schoolData_stuUse.vue?vue&type=style&index=0&id=7539d4c8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7539d4c8",
  null
  
)

export default component.exports